import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { i18n } from 'constant/String';
import UserInfoForm from './UserInfoForm';
import { isUserCompanySelector } from 'redux/slices/signUp/signUpSlice';
import {
  REGEX_EMAIL,
  REGEX_FULLNAME,
  REGEX_NUMERIC,
  REGEX_PASSWORD,
} from 'constant/Validation';

const UserInfo = ({ onNext, onPrev }) => {
  const isUserCompany = useSelector(isUserCompanySelector);
  const individualSchema = yup
    .object({
      name: yup
        .string()
        .required(i18n.errors.required)
        .test('hasNoNumbers', i18n.errors.fullNameNumeric, (value) => {
          return !/\d/.test(value);
        }),
      surname: yup
        .string()
        .required(i18n.errors.required)
        .test('hasNoNumbers', i18n.errors.fullNameNumeric, (value) => {
          return !/\d/.test(value);
        }),
      identityNumber: yup
        .string()
        .required(i18n.errors.required)
        .min(11, i18n.errors.tcMin)
        .max(11, i18n.errors.tcMax)
        .nullable(),
      email: yup
        .string()
        .required(i18n.errors.required)
        .matches(REGEX_EMAIL, i18n.errors.email),
      username: yup.string().required(i18n.errors.required),
      password: yup
        .string()
        .min(8, i18n.errors.passwordMin)
        .max(50, i18n.errors.passwordMax)
        .matches(REGEX_PASSWORD, i18n.errors.password)
        .required(i18n.errors.required),
      password2: yup
        .string()
        .oneOf([yup.ref('password'), null], i18n.errors.confirmPassword),
    })
    .required(i18n.errors.required);

  const companySchema = yup
    .object({
      fullName: yup
        .string()
        .required(i18n.errors.required)
        .test('hasNoNumbers', i18n.errors.fullNameNumeric, (value) => {
          return !REGEX_NUMERIC.test(value);
        })
        .test('hasSpace', i18n.errors.fullName, (value) => {
          return REGEX_FULLNAME.test(value);
        }),
      taxNumber: yup
        .string()
        .required(i18n.errors.required)
        .min(10, i18n.errors.vergMin)
        .max(11, i18n.errors.vergMax)
        .nullable(),
      email: yup
        .string()
        .required(i18n.errors.required)
        .matches(REGEX_EMAIL, i18n.errors.email),
      username: yup.string().required(i18n.errors.required),
      password: yup
        .string()
        .min(8, i18n.errors.passwordMin)
        .max(50, i18n.errors.passwordMax)
        .matches(REGEX_PASSWORD, i18n.errors.password)
        .required(i18n.errors.required),
      password2: yup
        .string()
        .oneOf([yup.ref('password'), null], i18n.errors.confirmPassword),
    })
    .required(i18n.errors.required);

  const methods = useForm({
    resolver: yupResolver(isUserCompany ? companySchema : individualSchema),
  });

  const onSubmit = () => {
    onNext();
  };

  return (
    <FormProvider {...methods}>
      <form
        onSubmit={methods.handleSubmit(onSubmit)}
        className="flex flex-col overflow-auto w-full gap-y-4 md:mt-10 items-center justify-center  h-full"
      >
        <UserInfoForm onNext={onSubmit} onPrev={onPrev} />
      </form>
    </FormProvider>
  );
};

UserInfo.propTypes = { onNext: PropTypes.func, onPrev: PropTypes.func };

export default UserInfo;
